import { Controller } from "@hotwired/stimulus";

function getColorScheme() {
  const match = document.cookie.match(
    /(?:^|;\s*)colorScheme=(light|dark)(?:;|$)/,
  );
  return match ? match[1] : null;
}

function setColorScheme(value) {
  const domain = window.location.hostname.split(".").slice(-3).join(".");
  if (value) {
    document.cookie = `colorScheme=${value}; path=/; domain=${domain}; max-age=${365 * 24 * 60 * 60}; SameSite=Lax`;
  } else {
    document.cookie = `colorScheme=; path=/; domain=${domain}; max-age=0; SameSite=Lax`;
  }
}

export default class extends Controller {
  static targets = ["system", "light", "dark"];

  connect() {
    this.systemTarget.addEventListener("click", (e) => {
      e.preventDefault();
      setColorScheme(null);
      document.documentElement.setAttribute("data-color-scheme", "system");
      if (
        window.matchMedia &&
        (window.matchMedia("(prefers-color-scheme: dark)").matches ||
          window.matchMedia("(prefers-color-scheme: no-preference)").matches)
      ) {
        document.documentElement.style.colorScheme = "dark";
        document.documentElement.classList.add("dark-mode");
      } else {
        document.documentElement.style.colorScheme = "light";
        document.documentElement.classList.remove("dark-mode");
      }
    });
    this.lightTarget.addEventListener("click", (e) => {
      e.preventDefault();
      document.documentElement.classList.remove("dark-mode");
      document.documentElement.setAttribute("data-color-scheme", "light");
      document.documentElement.style.colorScheme = "light";
      setColorScheme("light");
    });
    this.darkTarget.addEventListener("click", (e) => {
      e.preventDefault();
      document.documentElement.classList.add("dark-mode");
      document.documentElement.setAttribute("data-color-scheme", "dark");
      document.documentElement.style.colorScheme = "dark";
      setColorScheme("dark");
    });
  }
}
